/* eslint-disable no-restricted-imports */
import { format as formatDate, isDate } from 'date-fns'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import { z } from 'zod'
import { zodI18nMap } from 'zod-i18n-map'

import { LANGUAGES } from '@/common/constants/languages'
import { LOCALES } from '@/common/constants/locales'

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
    fallbackLng: 'pt',
    supportedLngs: LANGUAGES,
    ns: ['zod'],
    interpolation: {
      escapeValue: false,
      format: (value, format, lng) => {
        if (isDate(value)) {
          const locale = LOCALES[lng as keyof typeof LOCALES]
          return formatDate(value, format || 'P', { locale })
        }
        return String(value)
      },
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })

z.setErrorMap(zodI18nMap)

export { z }
export default i18n
